import { render, staticRenderFns } from "./StatementLink.vue?vue&type=template&id=04b6ab00&"
import script from "./StatementLink.vue?vue&type=script&lang=js&"
export * from "./StatementLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports